/* components/TabHeader.ts
Header Component for the tab container
Included within the tabContainer component

this just listens for click and dispatches an event to change the current active tab
usage outside of tab container:
<tab-header
        class="tab-header"
    >
        <button
            data-ref="buttons"
            role="presentation"
            type="button"
            name="{{whateverName}}"
            value="{{whateverValue }}"
            class="tab-header__button"
        >
            Whatver Button Text
        </button>
    </tab-header>

*/

import { Component, Prop, Ref, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class TextCollapse extends ThemeComponent {

    @Ref({required: false}) button!: HTMLButtonElement|null;
    @Ref({required: false}) target!: HTMLDivElement|null;

    init() {

        if (this.button && this.target) {

            this.$listen(this.button, 'click', () => {

                if (this.button && this.target) {
                    if (this.classList.contains('text-collapse--active')) {
                        this.classList.remove('text-collapse--active');
                        this.button.innerText = 'Read more';
                    } else {
                        this.classList.add('text-collapse--active');
                        this.button.innerText = 'Read less';
                    }
                }

            });
        }

    }
}
